import { supabase } from './supabase';
import type { ModuleKey } from './plans';

/**
 * Demande d'activation d'une option par un resto (« Activer » sur la vitrine).
 * Envoie une notification à Lil & Co (contact@yumlink.io) via l'Edge Function
 * `request-option`. L'activation réelle reste un geste du super admin.
 */
export interface RequestOptionInput {
  /** Requis pour créer la notif in-app ; optionnel pour la rétro-compat (email seul). */
  tenantId?: string;
  tenantName: string;
  tenantSlug: string;
  moduleKey: ModuleKey;
  moduleTitle: string;
  /** Email du resto → accusé de réception au client (optionnel). */
  tenantEmail?: string | null;
}

export async function requestOption(input: RequestOptionInput): Promise<{ ok: boolean; error?: string }> {
  const { data, error } = await supabase.functions.invoke('request-option', {
    body: {
      tenant_id: input.tenantId ?? '',
      tenant_name: input.tenantName,
      tenant_slug: input.tenantSlug,
      module: input.moduleKey,
      module_title: input.moduleTitle,
      tenant_email: input.tenantEmail ?? '',
    },
  });
  if (error) return { ok: false, error: error.message };
  const res = (data ?? {}) as { ok?: boolean; error?: string };
  if (!res.ok) return { ok: false, error: res.error ?? 'Demande impossible.' };
  return { ok: true };
}

export interface RequestPlanInput {
  tenantId?: string;
  tenantName: string;
  tenantSlug: string;
  planKey: string;   // 'gratuit' | 'medium' | 'premium'
  planLabel: string; // 'Medium', 'Premium'…
  /** Email du resto → accusé de réception au client (optionnel). */
  tenantEmail?: string | null;
}

/**
 * Demande d'une FORMULE complète (Gratuit / Medium / Premium). Même Edge que les
 * options (`request-option`) : c'est une notification à Lil & Co ; l'activation reste
 * un geste du super admin. Le module est préfixé `plan:` pour le distinguer dans l'email.
 */
export async function requestPlan(input: RequestPlanInput): Promise<{ ok: boolean; error?: string }> {
  const { data, error } = await supabase.functions.invoke('request-option', {
    body: {
      tenant_id: input.tenantId ?? '',
      tenant_name: input.tenantName,
      tenant_slug: input.tenantSlug,
      module: `plan:${input.planKey}`,
      module_title: `Formule ${input.planLabel}`,
      tenant_email: input.tenantEmail ?? '',
    },
  });
  if (error) return { ok: false, error: error.message };
  const res = (data ?? {}) as { ok?: boolean; error?: string };
  if (!res.ok) return { ok: false, error: res.error ?? 'Demande impossible.' };
  return { ok: true };
}
